import { render, staticRenderFns } from "./ReitsEtf.vue?vue&type=template&id=0ce614b6&scoped=true"
import script from "./ReitsEtf.vue?vue&type=script&lang=js"
export * from "./ReitsEtf.vue?vue&type=script&lang=js"
import style0 from "./ReitsEtf.vue?vue&type=style&index=0&id=0ce614b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce614b6",
  null
  
)

export default component.exports